"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var router_1 = require("@angular/router");
var service_service_1 = require("src/app/Services/service.service");
var WickedApiClient_1 = require("../../api/WickedApiClient");
var advertisement_service_1 = require("./../../../Services/advertisement.service");
var adv_user_advertisements_component_1 = require("./../../../Adveristments/adv-user-advertisements/adv-user-advertisements.component");
var NonDemoAdsComponent = /** @class */ (function (_super) {
    __extends(NonDemoAdsComponent, _super);
    function NonDemoAdsComponent(route, service) {
        var _this = _super.call(this, route, service) || this;
        _this.route = route;
        _this.service = service;
        _this.enableSubscription = false;
        _this.enableSubscription = service.enableSubscription;
        service.pageName = "Non Demo Ads";
        return _this;
    }
    NonDemoAdsComponent.prototype.ngOnInit = function () {
        if (!this.service.userService.isAdmin()) {
            this.service.route.navigate(["/"]);
        }
        if (!this.service.userService.isDemo()) {
            this.viewMode = advertisement_service_1.ViewMode.ACTIVE;
        }
        this.performSearch();
    };
    NonDemoAdsComponent.prototype.performSearch = function () {
        this.service.advService.searchDataUserAdv.currentSearchRule.nonDemoOnly = true;
        this.service.advService.searchDataUserAdv.currentSearchRule.userId = null;
        this.service.advService.searchActionForUser(this.viewMode);
    };
    Object.defineProperty(NonDemoAdsComponent.prototype, "pageEvent", {
        set: function (value) {
            this.service.advService.searchDataUserAdv.currentSearchRule.pageNumber = value.pageIndex;
            this.service.advService.searchDataUserAdv.currentSearchRule.pageSize = value.pageSize;
            this.service.advService.searchDataUserAdv.currentSearchRule.nonDemoOnly = true;
            this.service.advService.searchDataUserAdv.currentSearchRule.userId = null;
            this.service.advService.searchActionForUser(this.viewMode);
            this._pageEvent = value;
        },
        enumerable: true,
        configurable: true
    });
    NonDemoAdsComponent.prototype.hasAdvertismentImage = function (advertisment) {
        return advertisment.images.length > 0;
    };
    NonDemoAdsComponent.prototype.getLocation = function (adv) {
        return adv.subRegionName + ", " + adv.regionShortName;
    };
    NonDemoAdsComponent.prototype.getAdvDate = function (adv) {
        if (adv.dateStart != null) {
            return adv.dateStart.format("MM/DD/YYYY");
        }
        else
            return "";
    };
    NonDemoAdsComponent.prototype.getAdvTag = function (adv) {
        var tag = this.service.advService.searchDataStandard.currentSearchRule.advertisementCategoryId ? "" : "[" + adv.categoryCode + "] ";
        return "" + tag;
    };
    NonDemoAdsComponent.prototype.getAdvTitle = function (adv) {
        return "" + adv.title;
    };
    NonDemoAdsComponent.prototype.openAdv = function (id) {
        this.service.route.navigate(["adv-detail/" + id]);
    };
    NonDemoAdsComponent.prototype.editAdv = function (id) {
        this.service.route.navigate(["adv-edit/" + id]);
    };
    NonDemoAdsComponent.prototype.showTip = function (e) {
        e.stopPropagation();
        e.target.getElementsByClassName("textTip")[0].style.opacity = "1";
        setTimeout(function () {
            e.target.getElementsByClassName("textTip")[0].style.opacity = "0";
        }, 2000);
    };
    return NonDemoAdsComponent;
}(adv_user_advertisements_component_1.AdvUserAdvertisementsComponent));
exports.NonDemoAdsComponent = NonDemoAdsComponent;
